var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"header"}},[_c('picture',{staticClass:"img"},[_c('img',{attrs:{"src":require("@images/logo/logo-unifael-preta.png")}})])])}]

export { render, staticRenderFns }